import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class GrupoService extends BaseService {
  constructor() {
    super(`${ConfigApi.grupoURL}`);
    this.filter = new Filter();
  }

  getFilter() {
    return this.filter;
  }

  setFilter(filter) {
    this.filter = filter;
  }
}

class Filter {
  constructor() {
    this.razaoSocial = '';
    this.idMunicipio = 0;
    this.cnpj = '';
    this.limit = 11;
    this.page = 0;
  }
}
export default new GrupoService();
